import type { MaskitoOptions } from "@maskito/core";
import {
  MaskitoDateMode,
  maskitoDateRangeOptionsGenerator,
  maskitoWithPlaceholder,
} from "@maskito/kit";
import { makeZeroShortcutPreprocessor } from "../../../DateFieldSingle/internal/maskito/makeZeroShortcutPreprocessor";

export type DateMode = Extract<
  MaskitoDateMode,
  "dd/mm/yyyy" | "mm/dd/yyyy" | "yyyy/mm/dd"
>;

const datePlaceholderMask = ({
  mode,
  dateSeparator = "/",
  rangeSeparator = " - ",
  placeholder,
}: {
  mode: DateMode;
  dateSeparator?: string;
  rangeSeparator?: string;
  placeholder: string;
}) => {
  const dateRangeOptions = maskitoDateRangeOptionsGenerator({
    mode,
    dateSeparator,
    rangeSeparator,
  });

  const { plugins, removePlaceholder, ...placeholderOptions } =
    maskitoWithPlaceholder(placeholder);

  const datePlaceholderMask = {
    ...dateRangeOptions,
    plugins: plugins.concat(dateRangeOptions.plugins || []),
    preprocessors: [
      ...placeholderOptions.preprocessors,
      ...dateRangeOptions.preprocessors,
      makeZeroShortcutPreprocessor(placeholder, dateSeparator),
    ],
    postprocessors: [
      // NOTE this is super fragile. If Maskito maintainers change the order of the post-processors, this will break.
      // The last postprocessor is the date swap postprocessor, which we don't want to run.
      // A unit test is added to ensure this doesn't break on a dependency update.
      ...dateRangeOptions.postprocessors.slice(0, -1),
      ...placeholderOptions.postprocessors,
    ],
  } satisfies Required<MaskitoOptions>;

  return { options: datePlaceholderMask, removePlaceholder };
};

export default datePlaceholderMask;
